import { render } from "./CustomerNavDrawer.vue?vue&type=template&id=07b16b5c&ts=true"
import script from "./CustomerNavDrawer.vue?vue&type=script&lang=ts"
export * from "./CustomerNavDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__